"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dialog = require("@alicd/next/lib/dialog");

var _dialog2 = _interopRequireDefault(_dialog);

var _TaskOverlay = require("./TaskOverlay");

var _TaskOverlay2 = _interopRequireDefault(_TaskOverlay);

var _localeProvider = require("@alicd/next/lib/locale-provider");

var _localeProvider2 = _interopRequireDefault(_localeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TaskOverlayWithLocale = (0, _localeProvider2.default)(_TaskOverlay2.default);
TaskOverlayWithLocale.LOCALE = _dialog2.default.LOCALE;

TaskOverlayWithLocale.Setting = _TaskOverlay2.default.Setting;
TaskOverlayWithLocale.Content = _TaskOverlay2.default.Content;
TaskOverlayWithLocale.Footer = _TaskOverlay2.default.Footer;

exports.default = TaskOverlayWithLocale;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-task-overlay@0.0.22@@alicd/crui-task-overlay/lib/index.js
// module id = 154
// module chunks = 0